import {fromJS, Map} from 'immutable';
import userActions from '../actions/user.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {AccountInfo as BaseAccountInfo} from '@epic-node-services/common';

export interface AccountInfo extends BaseAccountInfo {
    isLoggedIn: boolean;
}

export interface UserState {
    loading: boolean;
    accountInfo: AccountInfo;
    checkingVerification: boolean;
    isLoggedIn: boolean;
}

export const DEFAULT_STATE = fromJS({
    loading: false,
    accountInfo: {
        id: null,
        email: null,
        displayName: null,
        preferredLanguage: null,
        country: null,
        tfaEnabled: false,
        emailVerified: false,
        isLoggedIn: false
    },
    checkingVerification: false,
    isLoggedIn: false
});

export const userReducer = (state: Map<keyof UserState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case userActions.TYPES.CHECK_SIGNUP_REQUIREMENTS_MET: {
            newState = newState.updateIn(['checkingVerification'], () => true);
            return newState;
        }
        case userActions.TYPES.CHECK_SIGNUP_REQUIREMENTS_MET_SUCCESS: {
            newState = newState.updateIn(['checkingVerification'], () => false);

            const {emailVerified, tfaEnabled} = action.payload.data;
            newState = newState.updateIn(['accountInfo', 'emailVerified'], () => emailVerified);
            newState = newState.updateIn(['accountInfo', 'tfaEnabled'], () => tfaEnabled);

            return newState;
        }
        case userActions.TYPES.CHECK_SIGNUP_REQUIREMENTS_MET_FAILED: {
            newState = newState.updateIn(['checkingVerification'], () => false);
            return newState;
        }
        case userActions.TYPES.LOGOUT: {
            return DEFAULT_STATE;
        }
        default:
            return state;
    }
};

export default dieselReducer('user', userReducer);
